import React, { FC } from 'react';

import { Button, Paper, Stack, Text } from '@mantine/core';
import { useSnapshot } from 'valtio';

import { LocalNotificationService, notificationsState } from 'services/LocalNotificationService';
import { RouterService } from 'services/RouterService';

import cx from './Notifications.module.scss';

const Notifications: FC = () => {
    const { notifications } = useSnapshot(notificationsState);
    const visible = notifications.filter((notification) => !notification.dismissed);

    return (
        <Stack
            className={cx.notifications}
            gap="xs"
            onMouseEnter={() => LocalNotificationService.stopToastScheduler()}
            onMouseLeave={() => LocalNotificationService.startToastScheduler()}
        >
            {visible.map((notification) => (
                <Paper
                    w="320"
                    p="sm"
                    onClick={() => {
                        if (notification.url) {
                            RouterService.push(notification.url).then();
                        }

                        LocalNotificationService.dismissToast(notification.id);
                    }}
                    withBorder
                    style={{
                        borderColor: 'var(--mantine-color-gray-2)',
                    }}
                >
                    {notification.title && (
                        <Text fz={12} fw={600}>
                            {notification.title}
                        </Text>
                    )}
                    <Text fz={12} dangerouslySetInnerHTML={{ __html: notification.description }} />
                    {notification.action && (
                        <Button
                            size="compact-xs"
                            mt="xs"
                            color="black"
                            onClick={(event) => {
                                event.stopPropagation();
                                notification.action?.onClick();
                                LocalNotificationService.dismissToast(notification.id);
                            }}
                        >
                            {notification.action.label}
                        </Button>
                    )}
                </Paper>
            ))}
        </Stack>
    );
};

export { Notifications };
